// URL-Tracker: speichert pathname + search (nie Hash), verändert die URL nicht
import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pathToPageKey, setLastPath } from '@utils/urlTracker';

export const URLTracker: React.FC = () => {
  const location = useLocation();
  const lastPathRef = useRef<string>('');

  const pathname = location.pathname || '/';
  const fullPath = pathname + (location.search || '');
  const shouldSave = pathToPageKey(pathname) != null;

  useLayoutEffect(() => {
    if (!shouldSave || fullPath === lastPathRef.current) return;
    lastPathRef.current = fullPath;
    setLastPath(fullPath);
  }, [pathname, location.search, shouldSave, fullPath]);

  return null;
};
